import { render, staticRenderFns } from "./homeTit.vue?vue&type=template&id=3dc515a2&scoped=true"
import script from "./homeTit.vue?vue&type=script&lang=js"
export * from "./homeTit.vue?vue&type=script&lang=js"
import style0 from "./homeTit.vue?vue&type=style&index=0&id=3dc515a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc515a2",
  null
  
)

export default component.exports